import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Button from '../button';
import EmptyStates from '../empty-states';

export const TooManyRequests = () => {
  const { t } = useTranslation();

  return (
    <EmptyStates
      title={t('too-many-requests.title')}
      content={t('too-many-requests.content')}
      controls={
        <Button onClick={() => window.location.reload()}>{t('too-many-requests.try-again')}</Button>
      }
    />
  );
};
